// A generated file endpoint (2xx schema `format: binary`) resolves to a
// File instead of parsed JSON. The name is read from Content-Disposition
// here because RTK Query keeps response headers in `meta`, which hooks
// never surface, while callers need it to save or title the download.
const FALLBACK_NAME = 'download';

function filenameFrom(headers: Headers): string {
  const match = headers.get('content-disposition')?.match(/filename="([^"]+)"/);
  return match?.[1] ?? FALLBACK_NAME;
}

export async function fileResponseHandler(
  response: Response
): Promise<unknown> {
  if (!response.ok) {
    // Error bodies are DRF JSON; keep them readable for the caller, the
    // way RTK's default json handler would.
    const text = await response.text();
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch {
      return text;
    }
  }
  return new File(
    [await response.arrayBuffer()],
    filenameFrom(response.headers),
    { type: response.headers.get('content-type') ?? '' }
  );
}
